export const LOCAL_STORAGE_ITEMS_KEYS = {
  AUTHENTICATION: "@UtronGMT_AuthenticationEntity",
  USER_PERSIST: "persist:user",
  SELECTED_SCOPE_PERSIST: "@UtronGmt_selectedScope"//"persist:selectedScope"
};

export const TABLES = {
  PARKERS: 1,
  GUESTS: 2,
  GMT: 3,
  CHARGE_ACCOUNTS: 4,
  BILLING_RULES: 5,
  EV_RULES: 6,
  OCCUPIED: 7,
  CAMPAIGNS: 8,
  MESSAGING_HISTORY: 9,
  MAILING_LIST: 10,
  MODAL_TABLE: 11,
  HISTORY: 12,
  BILLING_HISTORY: 13
};
export const PAGES = {
  DASHBORAD: "Dashboard",
  PARKERS: "Parkers",
  BILLING: "Billing",
  MESSAGING: "Messaging",
  ALLOCATIONS: "Allocations",
  VALIDATIONS: "Validations",
  HISTORY: "History",
  ADMIN: "Admin",
};

export const UTRON_PLARFORMS = {
  MOBILE: 1,
  DASHBORAD: 2,
  MAP: 3,
  GMT: 4,
};
export const USER_TYPES = {
  TRANSIENT: 1,
  TENANT: 2,
};

export const SERVER_ERROR_CODES = {
  ERR_NETWORK: "ERR_NETWORK",
  ECONNABORTED: "ECONNABORTED"
};

export const SERVER_ROUTES = {
  AUTHENTICATION: "/Authentication/",
  GET_INITIAL_STATE: "/InitialState/",
  LOGIN: "/Login/",
  FORGET_PASSWORD: "/Login/ForgetPassword/",
  VALIDATE_RESET_PASSWORD: "/Login/ValidateResetPasswordContent/",
  VALIDATE_SIGNUP_CONTENT: "/Signup/ValidateSignUpContent/",
  UNSUBSCRIBE: "/User/UnsubscribeContent/",
  REGION: "/Region/",
  SITE: "/Site/",
  SCOPE: "/Scope/",
  SCOPE_BY_USER: "/Scope/GetScopesByUser/",
  SCOPE_BY_SCOPE_ID: "/Scope/GetScopesByScopeId/",
  GET_WORKSPACE: "/Scope/GetScopesAndSites/",
  ADD_WORKSPACE: "/Scope/AddScopeAndSite/",
  UPDATE_WORKSPACE: "/Scope/UpdateScopeAndSite/",
  USER: "/User/",
  IS_USER_EXISTS: "/User/IsUserExists",
  GET_LOGGED_IN_USER: "/User/LoggedIn/",
  COLUMN: "/Column/",
  USERS_IDS: "/User/UsersIds/",
  USERS_MINIMAL_IDENTITY_DATA: "/User/UsersMinimalIdentityData/",
  GET_RECEIPT: "/Receipt/",
  SEND_VERIFICATION_CODE: "/VerificationCode/",
  //VERIFY_CODE: "/VerificationCode/VerifyAndAuthenticateUtronUser/",  
  VERIFY_CODE: "/VerificationCode/VerifyAndAuthenticate/",
  VERIFY_EMAIL: "User/IsEmailOk",
  VERIFY_KIOSK_PIN: "/UserAdditionalData/IsVerificationCodeOk/",
  VERIFY_KIOSK_LOGIN_NAME: "UserAdditionalData/IsKioskLoginNameOk",
  CREATE_USER: "/Signup/Gmt/Register/",
  REGISTER_EXSIST_USER: "/Signup/Gmt/RegisterExsistUser/",
  REGISTER_CHARGE_ACCOUNT_USER: "/Signup/Gmt/RegisterChargeAccountUser/",
  UPDATE_USER: "/User/",
  UPDATE_CHARGE_ACCOUNT_USER: "/User/UpdateChargeAccount/",
  DELETE_USER: "/User/",
  DELETE_CHARGE_ACCOUNT_USER: "/User/ChargeAccount/",
  UPDATE_USER_ACTIVATION: "/UserSite/",
  UPDATE_USER_SITES_ACTIVATION: "/UserSite/UserSitesActivation",
  ADD_USER_SITE: "/UserSite/",
  UNASSIGN_USER_SITE: "/UserSite/UnassignFacility/",
  ADD_CAR: "/Car/",
  DELETE_CAR: "/Car/",
  UPDATE_CAR: "/Car/UpdateCar/",
  CAR_IS_VALID: "/Car/IsValidCarDetails/",
  CAR_STATUS: "/CarStatus/GetCarStatus/",
  ASSIGN_CAR_USER_TOKEN: "/CarUserToken/AssignCarUserToken/",
  ASSIGN_COMMON_CAR_USER_TOKENS: "/CarUserToken/AssignCommonCarUserTokens/",
  GET_GMT_USERS: "/UserToPlatform/GetUsersByScopeAndPlatform/",
  GET_GMT_USERS_FOR_ADMIN: "/UserToPlatform/GetUsersByScopeAndPlatformForAdmin/",
  GET_CHARGE_ACCOUNTS: "/ChargeAccountToDiscount/GetChargeAccountToDiscountByUserIds/",
  RESET_PASSWORD: "/Login/ResetPassword/",
  UPDATE_USER_SCOPE: "/UserScope/UpdateUserScopesRole/",
  ADD_USER_SCOPE: "/UserScope/AddUserScopesRole/",
  DElETE_USER_SCOPE: "/UserScope/DeleteUserScopesRole/",
  INACTIVE_USER_SCOPE_LIST: "/UserScope/InactiveUserScopeRoleList/",
  DELETE_TOKEN: "/CarUserToken/DeleteCarUserTokensByTokenId/",
  CAR_USER_TOKEN: "/CarUserToken/UpdateCarUserTokenWithActiveModify/",
  CAR_USER_TOKEN_ACTIVATION: "/CarUserToken/UpdateCarUserTokensActivation/",
  CAR_USER_TOKEN_DELETE: "/CarUserToken/DeleteCarUserToken/",
  INVITE_NEW_GMT: "/Email/SendGmtInvitationEmail/",
  INVITE_CHARGE_ACCOUNT: "/Email/SendGmtChargeAccountInvitationEmail/",
  VALIDATIONS_SEARCH_USER: "/Discount/GetTokenForValidation/",
  ASSIGN_DISCOUNT: "/Discount/AssignDiscountForToken/",
  CHARGE_ACCOUNT_TO_DISCOUNT_BY_USER_ID: "/ChargeAccountToDiscount/GetChargeAccountToDiscountByUserId/",
  VALIDATION_HISTORIES_BY_CHARGE_ACCOUNT_ID: "/ValidationsHistory/GetValidationHistoriesByChargeAccountId/",
  VALIDATION_HISTORIES_BY_SITE_IDS: "/ValidationsHistory/GetValidationHistoriesBySiteIds/",
  BILLING_RULES_BY_SITE_ID: "BillingRules/BySiteIds/",
  BILLING_RULES: "BillingRules/",
  MAILING_LISTS: "/MailingList/",
  CAMPAIGN: "/Campaign/",
  GET_CAMPAIGN_ATTACHMENT_BY_ID: "/Campaign/GetCampaignAttachmentById/",
  MESSAGING_COST: "/MessagingCost/",
  MESSAGING_HISTORY_BY_CAMPAIGNS_IDS: "/MessagingHistory/ByCampaignsIds",
  MESSAGING_HISTORY_TO_MAILING_LIST_BY_MESSAGING_HISTORY_IDS: "/MessagingHistoryToMailingList/ByMessagingHistoryIds",
  VALIDATE_BY_PHONE_NUMBER: "User/ByPhoneNumber/",
  ALLOWED_NEW_PARKER_SITES: "/User/AllowedNewParkerSites",
  IS_USER_EXISTS_IN_USER_SITES: "/User/IsUserExistsInUserSites",
  IS_FOB_OK: "/CarUserToken/IsFobOk",
  CRYPTOGRAPHY_DECRYPT: "/Cryptography/Decrypt",
  GET_SELECTED_USER_DATA: "/User/GetSelectedUserData/"
};
export const CLIENT_ROUTES = {
  DASHBORAD: "/Dashborad",
  EDIT_PROFILE: "/EditProfile",
  PARKERS: "/Parkers",
  MESSAGING: "/Messaging",
  ALLOCATIONS: "/Allocations",
  BILLING: "/Billing",
  ADMIN: "/Admin",
  WORKSPACE: "/Workspace",
  VALIDATIONS: "/Validations",
  HISTORY: "/History",
  LOGIN: "/Login",
  RESET_PASSWORD: "/Reset/",
  UNSUBSCRIBE: "/Unsubscribe/",
  SIGNUP: "/GmtSignup/",
  DEFAULT: "/",
  LEGAL: "/Legal",
  NOT_FOUND: "*",
};

export const LEGAL_MENU_TYPES = {
  TERMS_OF_USE: "Terms Of Use",
  PRIVACY_POLICY: "Privacy Policy"
};

export const STATES_NAMES = {
  COMMON: "common",
  USER: "user",
  PARKERS: "parkers",
  BILLING: "billing",
  ALLOCATIONS: "allocations",
  MESSAGING: "messaging"
};
export const SEARCH_PROPS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  APP: "app",
  PHONE_NUMBER: "phoneNumber",
  NOTES: "utronUser.userAdditionalData",
  TOKEN: "mainCarToken.tokenDisplayName",
  WCA: "wca",
  SITES: "utronUser.userSites",
  PARKING: "mainCarToken.parkingStatus",
  CARD: "mainCarToken.tokenDisplayName",
  CAR_NUMBER: "mainCarToken.car.licensePlate",
  LICENSE_PLATE: "utronUser.cars",
  TIME: "time",
  DURATION: "duration",
  AMOUNT: "amount",
  ELECTRIC: "mainCarToken.car.isEVSupported",
  USER_TYPES: "utronUser.userToUserTypes",
  DELETED: "userSiteActivation.isActive",
  EMAIL: "email",
  RULE_NAME:"ruleName",
  VALID_DAYS: "validDays",
  VALID_HOURS: "validHours",
  RULE_USER_TYPES: "ruleUserTypes",
  EV_RULE_RATE_AMOUNT: "evRuleRateAmount",
  SITE_NAME:"site.displayName",
  CAR_USER_TOKENS: "utronUser.carUserTokens",
  CAR_USER_TOKENS_ALLOCATIONS: "token.value", // full token value - in allocations area
  PARKING_ALLOCATION: "token.displayValue", 
  PARKER_NAME: "parker.utronUser.firstName",
  PARKER_LAST_NAME: "parker.utronUser.lastName",
  ALLOCATION_TYPE: "token.userType.type",
  CAR_DETAILS: "car.manufacturer",
  CAR_LICENSE_PLATE: "car.licensePlate", 
  ALLOCATION_SITES: "token.site.userSites",
  FOB: "fob",
  CHARGE_ACCOUNT: "chargeAccount.name",
  DATE: "date",
  CREATED_DATE: "createdDate",
  DATE_CREATED: "dateCreated",
  DATE_SENT: "dateSent",
  VALIDATION_AMOUNT: "validationAmount",
  VALIDATION_TYPE: "validationType",
  CAMPAIGNS_CAMPAIGN_NAME: "name",                  // campaigns table
  MESSAGING_HISTORY_CAMPAIGN_NAME: "campaign.name", // messaging history table
  NUMBER_OF_RECIPIENTS: "numberOfRecipients",
  SIZE: "size"
};

export const PARKERS_PROPS = {
  NAME: "firstName",
  LAST_NAME: "lastName",
  APP: "app",
  PHONE_NUMBER: "phoneNumber",
  USER_ADDITIONAL_DATA: "utronUser.userAdditionalData",
  SUBSCRIBED: "utronUser.userAdditionalData.isMessagingEnabled",
  TOKEN: "mainCarToken.tokenDisplayName",
  WCA: "wca",
  SITES: "utronUser.userSites",
  PARKING: "mainCarToken.parkingStatus",
  CARD: "mainCarToken.tokenDisplayName",
  CAR_NUMBER: "mainCarToken.car.licensePlate",
  TIME: "time",
  DURATION: "duration",
  AMOUNT: "amount",
  ELECTRIC: "mainCarToken.car.isEVSupported",
  USER_TYPES: "utronUser.userToUserTypes",
  DELETED: "userSiteActivation.isActive",
  EMAIL: "email",
};
export const CAMPAIGN_PROPS = {
  CAMPAIGN_NAME: "campaignName",
  DATE_CREATED: "createdDate", // dateCreated
  CAMPAIGN_TYPE: "campaignType",
  SITES: "sites"
};
export const MESSAGING_HISTORY_PROPS = {
  CAMPAIGN_NAME: "campaignInfo.Name",
  DATE_SENT: "dateSent",
  CAMPAIGN_TYPE: "campaignInfo.Type",
  NUMBER_OF_RECIPIENTS: "numberOfRecipients",
  SITES: "sites",
  TOTAL: "total"
};
export const MAILING_LISTS_PROPS = {
  MAILING_LIST_NAME: "mailingListName",
  DATE_CREATED: "dateCreated", // dateCreated
  SIZE: "size",
  SITES: "sites"
};
export const MESSAGING_PARKERS_PROPS = {
  NAME: "name",
  EMAIL: "email",
  PHONE_NUMBER: "phoneNumber",
  TYPE: "type"
};
export const RECIPIENTS_PROPS = {
  NAME: "name",
  EMAIL: "email",
  PHONE_NUMBER: "phoneNumber",
  TYPE: "type",
  STATUS: "status",
  SUBSCRIPTION_STATUS: "subscriptionStatus",
  REASON: "reason"
};
export const GMT_PROPS = {
  NAME: "firstName",
  LAST_NAME: "lastName",
  EMAIL: "email",
  PHONE_NUMBER: "phoneNumber",
  SUBSCRIBED: "utronUser.userAdditionalData.isMessagingEnabled",
  SITES: "utronUser.userSites",
};
export const CHARGE_ACCOUNTS_PROPS = {
  NAME: "name",
  EMAIL: "email",
  CONTACT: "contact",
  VALIDATION: "validation",
  NOTES: "notes"
};
export const BILLING_PROPS = {
  RULE_NAME: "ruleName",
  LAST_MODIFIED: "modifiedDate",
  SITES: "site",
  VALID_DAYS: "days",
  VALID_HOURS: "startTime",
  USER_TYPES: "billingRuleToUserTypes",
  RATE: "billingRuleRates",
  OPTIONS: "options"
};
export const ALLOCATION_PROPS = {
  PARKING_ALLOCATION: "token.displayValue",
  PARKER_NAME: "parker.firstName",
  ALLOCATION_TYPE: "token.userType.type",
  CAR_DETAILS: "car.manufacturer",
  ALLOCATION_SITES: "token.site.userSites",
  FOB: "fob"
};
export const HISTORY_PROPS = {
  CHARGE_ACCOUNT: "chargeAccount.name",
  DATE: "date",
  VALIDATION_AMOUNT: "validationAmount",
  VALIDATION_TYPE: "validationType",
  PHONE_NUMBER: "phoneNumber",
  EMAIL: "email"
};

export const CURRENCIES = {
  USD: "USD",
  ILS: "ILS",
};

export const SITES = {
  TestSite: "SITE_1",
  UCLA: "SITE_2",
  One_Park: "SITE_3",
  Monroe: "SITE_4",
  _1415: "SITE_5",
  Yarkon: "SITE_6",
  Broadway: "SITE_7",
  Electra_EIGER: "SITE_8",
  Electra_Frenkel: "SITE_9",
  Electra_LAPIN: "SITE_10",
  Electra_Melchet: "SITE_11",
  Electra_NesZiona: "SITE_12",
  Hoboken_VINE: "SITE_13",
  OPOS: "SITE_14",
  Pearl_West: "SITE_15",
  Rock_Farmer: "SITE_16",
  WEHO: "SITE_17",
};

export const PARKING_STATUSES = {
  IN: 1,
  OUT: 2,
  INACTIVE: 0,
  ACTIVE: 3
};

export const SUBSCRIPTION_STATUSES = {
  SUBSCRIBED: 1,
  UNSUBSCRIBED: 0,
};

export const MENU_ITEMS = {
  EDIT: "Edit",
  DELETE: "Delete",
  EDIT_PROFILE: "Edit Profile Details",
  DISACTIVE_USER: "Deactivate User",
  ACTIVE_USER: "Activate User",
  PARKER_ACTIVATION: "Activate / Deactivate Parker",
  TOKENS: "Parking Allocations",
  ADD_CAR: "Add Car",
  MANAGE_FACILITIES: "Manage Facilities",
  DELETE_USER: "Delete User",
  MY_PROFILE: "My Profile",
  LEGAL: "Legal",
  LOGOUT: "Logout",
  EDIT_CAMPAIGN: "Edit Campaign",
  DUPLICATE_CAMPAIGN: "Duplicate Campaign",
  DELETE_CAMPAIGN: "Delete Campaign",
  DELETE_MESSAGE_HISTORY: "Delete from history",
  EDIT_LIST: "Edit List",
  DELETE_LIST: "Delete List",
  PERMISSIONS: "Add Permissions",
  EDIT_PERMISSIONS: "Edit Permissions",
  DISACTIVE_PERMISSION: "Deactivate User",
  GMT_USER_MANAGEMENT: "GMT User Management",
  WORKSPACE_CONFIGURATION: "Workspace Configuration",
  DEACTIVATE_ALLOCATION: "Deactivate allocation",
  ACTIVATE_ALLOCATION: "Activate allocation",
  ACTIVATE_FOB: "Activate Key-FOB",
  DEACTIVATE_FOB: "Deactivate FOB",
  EDIT_KEY_FOB: "Edit Key-FOB",
  REMOVE_PARKER_ALLOCATION: "Remove parker from allocation",
  ADD_PARKER: "Add Parker",
  DEACTIVATE_TOKEN: "Deactivate Token",
  ACTIVATE_TOKEN: "Activate Token",
  OPEN_ALLOCATION_MANAGEMENT: "Open allocation management"
};

export const CAMPAIGN_TYPES = {
  MOBILE: 1,
  MAIL: 2,
};

export const SEND_STATUSES = {
  DELIVERED: "Delivered",
  MISSING_EMAIL: "Missing email",
  MISSING_PHONE: "Missing phone"
};

export const RECIPIENT_SELECTION_TYPES = {
  MAILING_LIST: "Mailing List",
  USER: "User",
  OTHER: "Other"
};

export const VERIFICATION_TYPES = {
  MOBILE: 0,
  MAIL: 1,
};
export const DIALING_CODES = {
  US: "1",
  IL: "972",
};

export const CHARGING_POSITIONS = {
  FRONT: 1,
  FRONT_RIGHT: 2,
  FRONT_LEFT: 3,
  BACK_RIGHT: 4,
  BACK_LEFT: 5,
  BACK: 6
};

export const ADD_PARKER_FORM_STEPS = {
  GENERAL_DETAILS: 1,
  USER_TYPE: 2,
  ADD_TOKENS: 3,
  ADD_CARS: 4,
  SUMMARY: 5,
  TOTAL_STEPS: 5,
  EDIT_TOTAL_STEPS: 1,
  ADD_PARKER_FORM_STEPS: 6,
  EDIT_STEP: 7,
  ADD_PERMISSIONS: 8,
  INVITE_NEW_GMT: 9,
};

export const ADD_CHARGE_ACCOUNT_FORM_STEPS = {
  CREATE_NEW_CHARGE_ACCOUNT: 1
};

export const ADD_CAMPAIGN_FORM_STEPS = {
  CAMPAIGN_DETAILS: 1,
  RECIPIENTS: 2,
  CAMPAIGN_REVIEW: 3
};

export const ADD_MAILING_LIST_FORM_STEPS = {
  MAILING_LIST_DETAILS: 1
};

export const ADD_WORKSPACE_FORM_STEPS = {
  ACTIONS: 1,
  SCOPE_DETAILS: 2,
  GENERAL_DETAILS: 3,
  TECH: 4,
  PRODUCTS: 5,
  PRODUCTS_TWO: 6,
  ADDITIONAL_INFO: 7,
  USER_TYPES: 8,
  SUMMARY: 9
}

export const ADD_EV_RULE_FORM_STEPS = {
  ADD_EV_RULE: 1
};

export const ADD_BILLING_RULE_FORM_STEPS = {
  ADD_BILLING_RULE: 1,
  ADD_RATE: 2,
  ADD_BILLING_RULE_TOTAL_STEP:2
};

export const ADD_PARKING_ALLOCATION_STEPS = {
  TOTAL_STEPS: 2,
  USER_TYPE: 2,
  ADD_TOKENS: 3,
};

export const ADD_PARKER_ALLOCATION_STEPS = {
  TOTAL_STEPS: 2, // 2
  ADD_TOKENS: 1, // 3
  USER_TYPE: 2, // 2
  ALLOCATION_MANAGEMENT_INFO: 4
};

// Allocations area
export const ADD_ALLOCATIONS_FORM_STEPS = {
  USER_TYPE: 2,
  SEARCH_PARKER: 3
};

export const INPUTS_PROPS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  DIALING_CODE: "dialingCode",
  PHONE_NUMBER: "phoneNumber",
  PHONE_VERIFIED: "isPhoneVerified",
  CODE_VERIFIED: "isCodeVerified",
  VERIFIED_FROM_GMT: "isVerifiedFromGmt",
  EMAIL: "email",
  PERSIONAL_PIN: "kioskPIN",
  PERSIONAL_ID: "kioskLoginName",
  IS_STEP_SUBMITTED: "isStepSubmitted",
  IS_MESSAGING_ENABLED: "isMessagingEnabled",
  PROFILE_PICTURE: "profilePicture",
  APP: "app",
  USER_TYPE: "userType",
  SITE: "site",
  SELECTED_SITE: "selectedSite",
  SCOPE: "scope",
  CAR_NAME: "nickname",
  CAR_COLOR: "color",
  LICENCE_PLATE: "licensePlate",
  EV_CHARGING: "isEVSupported",
  CHARGING_POSITION: "chargingPosition",
  AVA_CAR: "isWheelchairAccess",
  MANUFACTURE: "manufacturer",
  VEHICLE_TYPE: "vehicleType",
  FROM_GMT: "fromGmt",
  OLD_PIN: "oldPersonalPin",
  NEW_PIN: "newPersonalPin",
  VERIFY_NEW_PIN: "verifyNewPersonalPin",
  NOTES: "notes",
  CARS: "cars",
  TOKEN: "token",
  FOB: "fob",
  IS_PAYING: "isPaying",
  TOKENS: "tokens",
  CAR_USER_TOKEN: "carUserTokens",
  IS_ETICKET_USER: "isETicketUser",
  IS_USER_CREATED_FROM_APP: "isUserCreatedFromApp",
  IS_GMT_USER: "isGmtUser",
  EXSIST_USER: "exsistUserEntity",
  EXSIST_USER_IDENTITY:"exsistUserIdentityEntity",
  PASSWORD: "password",
  CURRENT_PASSWORD: "currentPassword",
  NEW_PASSWORD: "newPassword",
  REPEAT_PASSWORD: "repeatPassword",
  ROLE: "role",
  BILLING_USER_TYPE: "userType",
  RULE_NAME: "ruleName",
  COST_PER_KV: "costPerKV",
  START_TIME:"startTime",
  END_TIME:"endTime",
  DAYS:"days",
  RATES:"rates",
  RATE_AMOUNT: "rateAmount",
  CHARGE_BY: "chargeBy",
  NUMBER_OF_PERIODS: "period",
  IS_ACCEPTED_MOBILE_TERMS_AND_POLICIES: "isAcceptedMobileTermsAndPolicies",
  IS_NEW_SCOPE: "isNewScope", 
  SCOPE_NAME: "scopeName",
  SITE_NAME: "siteName",
  SCOPE_TYPE: "scopeType",
  PROJECT_TYPE: "projectType",
  SELECTED_SCOPE: "selectedScope", 
  MAILING_LIST_NAME: "mailingListName",
  MAILING_LIST_PARKERS: "mailingListParkers",
  MAILING_LIST_ADD_PARKERS: "mailingListAddParkers",
  CAMPAIGN_ID: "campaignId",
  CAMPAIGN_TYPE: "campaignType", 
  CAMPAIGN_NAME: "campaignName", 
  EMAIL_SUBJECT: "emailSubject",
  MESSAGE_BODY: "messageBody",
  LINK: "link",
  GENERATED_LINK: "generatedLink",
  ATTACHMENT: "attachment",
  RECIPIENTS: "recipients",
  CHARGE_ACCOUNT_NAME: "chargeAccountName",
  CONTACT_NAME: "contactName", 
  CONTACT_FIRSTNAME: "contactFirstName",
  CONTACT_LASTNAME: "contactLastName",
  IS_FULL_VALIDATION: "isFullValidation",
  VALIDATION_TYPE: "validationType",
  PAYMENT_DISTRIBUTION: "paymentDistribution", 
  LICENSE_NUMBER: "licenseNumber",
  TIMEZONE: "timeZone", 
  REGION: "region",
  CURRENCY: "currency",
  APMS_IOT_DEVICE_NAME: "apmsIotDeviceName",
  HEALTH_CHECK_IOT_DEVICE_NAME: "healthCheckIotDeviceName",
  PARKING_TAX_RATE: "parkingTaxRate",
  EV_TAX_RATE: "evTaxRate",
  DISCOUNT_TYPE: "discountType", 
  AMOUNT: "amount",
  SITE_DISPLAY_NAME: "siteDisplayName",
  SITE_FULL_ADDRESS: "siteFullAddress",
  USER_TYPE_NAME: "userTypeName", 
  DAILY_MAX: "dailyMax",
  SELECTED_PARKER: "selectedParker"
};

export const EMAIL_TEMPLATE = {
  MOBILE_APP_WELCOME_MAIL_TEMPLATE_ID: 1,
  VERIFICATION_CODE_MAIL_TEMPLATE_ID: 2,
  KIOSK_E_TICKET_MAIL_TEMPLATE_ID: 3,
  INTENTIONAL_MAIL_TEMPLATE_ID: 4,
  GMT_WELCOME_MAIL_TEMPLATE_ID: 5,
  GMT_WELCOME_MAIL_ACTIVE_APP_TEMPLATE_ID: 6,
};

export const VERIFICATION_TYPE = {
  MOBILE: 0,
  MAIL: 1,
};

export const ASSIGN_OPTIONS = {
  NEW: 1,
  EXSIST: 2,
};

export const ROLES_HIERARCHY = {
  ADMINISTRATOR: 1,
  OPERATOR: 2,
  COLLABORATOR: 3,
  VIEWER: 4,
  CUSTOMER: 5,
  CHARGE_ACCOUNT: 6,
  INACTIVE: 999
};

export const ROLES_NAMES = {
  ADMINISTRATOR: "Administrator",
  OPERATOR: "Operator",
  COLLABORATOR: "Collaborator",
  VIEWER: "Viewer",
  CUSTOMER: "Customer",
  CHARGE_ACCOUNT: "Charge Account",
  INACTIVE: "Inactive"
}

export const SCOPE_TYPE = {
  GLOBAL: "Global",
  DISTRIBUTER: "Distributer",
  PROJECT: "Project",
};

export const BILLING_RULE_TYPE = {
  PARKING_RULE: "ParkingRule",
  EV_RULE: "EvRule",
};

export const PAYMENT_PART_NAMES = {
  PARKING: "Parking",
  EV_CHARGE: "EV Charging",
  PARKING_TAX: "Parking Tax",
  EV_TAX: "EV Tax",
  DISCOUNT: "Discount"
};

export const DISCOUNT_TYPE = {
  CURRENCY: 1,
  PERCENTAGE: 2
};

export const VEHICLE_TYPE = {
  CAR: 0,
  STORAGE: 1
};

export const VALIDATION_DISCOUNT_TYPE = {
  FULL: 1,
  PARTIAL: 2
};

export const INVITATION_TYPE = {
  GMT: 1,
  CHARGE_ACCOUNT: 2
};

export const ACTIVATION_TYPE = {
  NON_ACTIVE: "Non-Active",
  ACTIVE: "Active"
};

export const VALIDATION_TYPE = {
  FULL: "Full Validation",
  PARTIAL: "Partial Validation"
};

// export const DAYS = {
//   4: "Monday",
//   8: "Tuesday",
//   16: "Wednesday",
//   32: "Thursday",
//   64: "Friday",
//   128: "Saturday",
//   2: "Sunday"
// };

// Valid file extension types for attachment 
export const ATTACHMENT_FILE_TYPES = {
  PNG: ".png",
  JPEG: ".jpeg",
  JPG: ".jpg",
  WEBP: ".webp",
  TIF: ".tif",
  TIFF: ".tiff",
  BMP: ".bmp",
  PDF: ".pdf",
  DOC: ".doc",
  DOCX: ".docx",
  XLS: ".xls",
  XLSX: ".xlsx",
  CSV: ".csv",
  PPT: ".ppt",
  PPTX: ".pptx"
};

export const DAYS = {
  1: {value: 4, name: "Monday"},
  2: {value: 8, name: "Tuesday"},
  3: {value: 16, name: "Wednesday"},
  4: {value: 32, name: "Thursday"},
  5: {value: 64, name: "Friday"},
  6: {value: 128, name: "Saturday"},
  7: {value: 2, name: "Sunday"}
};

export const BILLING_RULE_TYPES = {
  PARKING_RULE: "ParkingRule",
  EV_RULE: "EvRule"
};
export const RATE_CHARGE_BY_NAMES = {
  MINUTES: "Minutes",
  HOURS : "Hours",
  KV: "KV"
}

export const RATE_CHARGE_BY_VALUES = {
  MINUTES: 30,
  HOURS : 1
}


